<template>
  <v-card
    dark
    class="primary darken-1"
    height="327"
    :width="width"
    :min-width="minWidth"
    style="border-radius: 5px; overflow-y: auto"
  >
    <v-expand-transition>
      <div
        v-if="estimation"
        class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
      >
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon
                large
                color="secondary lighten-1"
                @click="toggleEstimation"
              >mdi-arrow-left-circle</v-icon
              >
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1">sort</v-icon>
            </v-col>
          </v-row>
          <br />
          {{ estimationText }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!estimation">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"
        ><v-icon small>restore</v-icon> atualizado em</span
        ><br />
        <span class="textDate" v-if="indicator">{{ indicator.params.data_dado }}</span>
        <span class="textDate" v-else>dd/mm/aaaa</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large> sort </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <strong class="textTitle">Estimativa de Cargas Difusas</strong>
        <v-tooltip right color="#1A232F">
          <template v-slot:activator="{on, attrs}">
            <v-icon
              class="ml-1"
              color="secondary lighten-1"
              v-bind="attrs"
              v-on="on"
              @click="toggleEstimation"
            >
              help_outline
            </v-icon>
          </template>
          <span>Clique para informações</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row dense no-gutters>
          <v-col cols="6">
            <span class="textItem">DBO</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{ location ? normalizeValue(carga[0].indcarga.DBO_kg_dia) : normalizeValue(indicator.vals.DBO) }} </strong><span class="textItemSuffix"> kg/dia</span>
          </v-col>
          <v-col cols="6">
            <span class="textItem">PT</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{ location ? normalizeValue(carga[0].indcarga.PT_kg_dia) : normalizeValue(indicator.vals.PT) }} </strong><span class="textItemSuffix"> kg/dia</span>
          </v-col>
          <v-col cols="6">
            <span class="textItem">NT</span>
          </v-col>
          <v-col cols="6">
            <strong class="textItemValue">{{ location ? normalizeValue(carga[0].indcarga.NT_kg_dia) : normalizeValue(indicator.vals.NT) }} </strong><span class="textItemSuffix"> kg/dia</span>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CardEstimation',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    },
    location: {
      required: true,
    },
    carga: {
      required: true,
    },
    indicator: {
      required: true,
    },
  },
  data() {
    return {
      estimation: false,
      estimationText:
        'As estimativas de cargas difusas foram geradas a partir da quantificação das classes do Uso e Cobertura da Terra, desenvolvido pelo Simepar (2021).Foram usados coeficientes de exportação de cargas difusas obtidas a partir de literatura e gerou-se uma estimativa da geração de cargas de DBO (Demanda Bioquímica de Oxigênio), NT (Nitrogênio Total) e PT (Fósforo Total) para cada manancial. De forma a minimizar a influência do tamanho da bacia na geração das emissões de cargas difusas, são apresentadas as cargas difusas de DBO, PT e NT normalizadas pelo tamanho da bacia de manancial.',
    };
  },
  methods: {
    toggleEstimation() {
      this.estimation = !this.estimation;
    },
    normalizeValue(value) {
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}
.textItem {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}
.textItemValue {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
}
.textItemSuffix {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
